export const HERO_VARIANTS = [
  {
    id: "diwali",
    name: "Diwali diyas",
    video: "/videos/diwali.mp4",
    poster: "/videos/diwali-poster.jpg",
  },
  {
    id: "himalayas",
    name: "Himalayan dusk",
    video: "/videos/himalayas.mp4",
    poster: "/videos/himalayas-poster.jpg",
  },
  {
    id: "shimla",
    name: "Shimla sunset",
    video: "/videos/shimla.mp4",
    poster: "/videos/shimla-poster.jpg",
  },
];

export const EXPERIMENT_KEY = "desi_hero_video";
export const SESSION_KEY = "nema_session_id";
export const VARIANT_KEY = "nema_desi_hero_variant";

const genSessionId = () =>
  (crypto?.randomUUID?.() || `s-${Math.random().toString(36).slice(2, 10)}-${Date.now()}`);

export const getSessionId = () => {
  try {
    let sid = localStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid = genSessionId();
      localStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  } catch {
    return genSessionId();
  }
};

export const pickVariant = () => {
  try {
    const url = new URL(window.location.href);
    const forced = url.searchParams.get("variant");
    if (forced) {
      const match = HERO_VARIANTS.find((v) => v.id === forced);
      if (match) return match;
    }
    const cached = sessionStorage.getItem(VARIANT_KEY);
    if (cached) {
      const match = HERO_VARIANTS.find((v) => v.id === cached);
      if (match) return match;
    }
    const chosen = HERO_VARIANTS[Math.floor(Math.random() * HERO_VARIANTS.length)];
    sessionStorage.setItem(VARIANT_KEY, chosen.id);
    return chosen;
  } catch {
    return HERO_VARIANTS[0];
  }
};
